import lazyLoading from '../utils'
import { routes as dashboard } from './dashboard'
import { routes as catalog } from './catalog'
import { routes as documents } from './documents'
import { routes as balance } from './balance'
import { routes as pricelist } from './pricelist'
// import { routes as contacts } from './contacts'
import { routes as user } from './user'
import { routes as auth } from './auth'
import multiguard from 'vue-router-multiguard'
import AuthGuard from './authGuard'
import UserGuard from './userGuard'

export default [
  {
    path: '/',
    component: lazyLoading('tradle/components/Tradle'),
    beforeEnter: multiguard([AuthGuard, UserGuard]),
    children: [
      ...dashboard,
      ...catalog,
      ...documents,
      ...balance,
      ...pricelist,
      // ...contacts,
      ...user
    ]
  },
  {
    path: '/auth',
    component: lazyLoading('auth/components/Layout'),
    children: [
      ...auth
    ]
  }
]
